import * as React from 'react';

import { InlineNotification } from '@coursera/cds-core';
import type { InlineNotificationProps } from '@coursera/cds-core';

import 'css!./__styles__/FeedbackComplete';

type Props = {
  hideDelay?: number;
  onTimeout: () => void;
  title?: InlineNotificationProps['title'];
  children: string;
};

class FeedbackComplete extends React.Component<Props> {
  static defaultProps = {
    hideDelay: 5000,
  };

  componentDidMount() {
    const { onTimeout, hideDelay } = this.props;
    this._hideCompleteTimer = window.setTimeout(() => {
      onTimeout();
    }, hideDelay);
  }

  componentWillUnmount() {
    if (this._hideCompleteTimer) {
      clearTimeout(this._hideCompleteTimer);
    }
  }

  _hideCompleteTimer: number | null = null;

  render() {
    const { title, children } = this.props;

    return (
      <InlineNotification title={title} severity="success" className="rc-FeedbackComplete">
        {children}
      </InlineNotification>
    );
  }
}

export default FeedbackComplete;
